module.exports = __webpack_public_path__ + "static/media/right-arrow.7f943b00.svg";